import React, { useEffect } from "react"
import { useIntl } from "react-intl"
import { useDispatch, useSelector } from "react-redux"
import PropTypes from "prop-types"
import { Button, Typography } from "@material-ui/core"

import documentSlice from "./documentSlice"
import SigningCeremonyTemplate from "./SigningCeremonyTemplate"
import useStyles from "./signingCeremonyStyle"
import intlMessages from "./signingCeremonyIntl"
import { CancelToken } from "../../api/httpClient"

const { actions } = documentSlice

export default function SigningCeremonyStarter(props) {
  const { formName, id, children } = props
  const classes = useStyles()
  const { formatMessage: format } = useIntl()
  const esignView = useSelector((state) => state.documents.esignView)
  const dispatch = useDispatch()

  useEffect(() => {
    const { token, cancel } = CancelToken.source()
    dispatch(actions.fetchEsignView(id, token))
    return () => cancel()
  }, [dispatch, id])

  const messages = {
    title: intlMessages.starterTitle,
    mainInfo: intlMessages.starterMainInfo,
    subInfo: intlMessages.starterSubInfo,
    button: intlMessages.finish
  }

  return (
    <>
      {/* children contains alert message in case of issues */}
      {children}
      <SigningCeremonyTemplate messages={messages} formName={formName}>
        <Typography component="span" paragraph>
          {format(intlMessages.starterMainInfo, {
            formName: <strong key="1">{formName}</strong>
          })}
        </Typography>
        <Typography component="span" paragraph>
          {format(intlMessages.starterSubInfo, {
            docusign: <strong key="2">DocuSign®</strong>
          })}
        </Typography>
        <Typography component="span" paragraph>
          {format(intlMessages.starterExplanation, {
            list: (
              <ul key="3">
                <li key="4">{format(intlMessages.signDocumentLater)}</li>
                <li key="5">{format(intlMessages.signDocument)}</li>
                <li key="6">{format(intlMessages.declineDocument)}</li>
              </ul>
            )
          })}
        </Typography>
        <Button
          variant="outlined"
          color="secondary"
          className={classes.button}
          href={esignView && esignView.redirectUrl}
          disabled={!esignView}
        >
          {format(intlMessages.continue)}
        </Button>
      </SigningCeremonyTemplate>
    </>
  )
}

SigningCeremonyStarter.propTypes = {
  formName: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
}

SigningCeremonyStarter.defaultProps = {
  children: undefined
}
